exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-wrapper>video[data-v-f5806d24]{width:100%;vertical-align:middle;max-width:100%;max-height:100%}.video-wrapper>video.has-media-controls-hidden[data-v-f5806d24]::-webkit-media-controls{display:none}.video-overlay-play-button[data-v-f5806d24]{box-sizing:border-box;width:100%;height:100%;padding:10px calc(50% - 50px);position:absolute;top:0;left:0;display:block;cursor:pointer;transition:opacity .15s;--color:#fff}.video-overlay-play-button[data-v-f5806d24]:hover{opacity:1}.video-overlay-play-button.is-hidden[data-v-f5806d24]{display:none}", ""]);

// exports
